// extracted by mini-css-extract-plugin
module.exports = {"matchesContainer":"matchesList_matchesContainer__FNRse"};